module.exports = __webpack_public_path__ + "media/images/tiedye/comfy-d5dd72a093afc75384590d3cb55672be.png";